(() => {
  let timer;
  let refreshTimer;
  const refresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('waxer:cart-changed'));
      document.querySelectorAll('waxer-shipping-summary').forEach(summary => summary.refreshCart?.());
    }, 100);
  };
  const alignToast = () => {
    const toast = document.getElementById('vf-cart-added-toast');
    const anchor = document.getElementById('HeaderMiniCart');
    if (!toast || !anchor) return;
    const bounds = anchor.getBoundingClientRect();
    const mobile = window.innerWidth < 750;
    const width = Math.min(mobile ? window.innerWidth - 24 : 512, window.innerWidth - 32);
    toast.style.width = `${width}px`;
    toast.style.boxSizing = 'border-box';
    toast.style.maxWidth = 'none';
    toast.style.left = 'auto';
    toast.style.right = `${mobile ? 12 : Math.max(16, document.documentElement.clientWidth - bounds.right)}px`;
    const viewport = window.visualViewport;
    const viewportTop = viewport?.offsetTop || 0;
    const minimumTop = viewportTop + (mobile ? 100 : 110);
    const maximumTop = viewportTop + (viewport?.height || window.innerHeight) - toast.offsetHeight - 16;
    const top = Math.max(viewportTop + 16, Math.min(Math.max(minimumTop, bounds.bottom + 16), maximumTop));
    toast.style.setProperty('position', 'fixed', 'important');
    toast.style.setProperty('top', `${top}px`, 'important');
    toast.style.setProperty('bottom', 'auto', 'important');
    toast.style.pointerEvents = toast.classList.contains('is-visible') ? 'auto' : 'none';
  };
  const positionCart = () => {
    const cart = document.getElementById('HeaderMiniCart');
    if (!cart || cart.getAttribute('open') !== 'true') return;
    const header = document.querySelector('.header');
    const top = Math.max(16, Math.min(130, header?.getBoundingClientRect().bottom || 90));
    cart.style.setProperty('--waxer-cart-top', `${top}px`);
    const right = Math.max(16, document.documentElement.clientWidth - cart.getBoundingClientRect().right);
    cart.style.setProperty('--waxer-cart-right', `${right}px`);
  };
  const dismiss = () => {
    clearTimeout(timer);
    const toast = document.getElementById('vf-cart-added-toast');
    if (toast) { toast.classList.remove('is-visible'); toast.style.pointerEvents = 'none'; }
  };
  if (typeof subscribe === 'function') {
    subscribe('cart:item-add', () => {
      clearTimeout(window.vfCartAddedToastTimer);
      clearTimeout(timer);
      timer = setTimeout(dismiss, 2000);
      alignToast();
      requestAnimationFrame(alignToast);
      refresh();
    });
    ['cart:item-remove','cart:item-quantity-update','cart:update','header-cart:open'].forEach(event => subscribe(event, refresh));
    subscribe('header-cart:open', () => requestAnimationFrame(positionCart));
  }
  window.addEventListener('resize', positionCart, {passive:true});
  window.addEventListener('resize', alignToast, {passive:true});
  window.addEventListener('scroll', dismiss, {passive:true});
  window.addEventListener('wheel', dismiss, {passive:true});
  window.addEventListener('touchmove', dismiss, {passive:true});
})();
